import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import { showHelperText } from '../../commercial/Switch/utils';
import { getRelationShip } from '../../portfolios/utils';

export default function ({ mobileFormik }: any) {
    return (
        <div style={{ marginTop: 20, maxWidth: 350, width: '100%' }}>
            <FormControl variant="outlined">
                <InputLabel htmlFor="mobileRelationship" variant="outlined">
                    {' '}
                    Mobile Relationship
                </InputLabel>
                <Select
                    name="mobileRelationship"
                    value={mobileFormik.values.mobileRelationship}
                    onChange={mobileFormik.handleChange}
                    aria-invalid={!!mobileFormik.errors.mobileRelationship}
                    aria-describedby={mobileFormik.errors.mobileRelationship ? 'mobileRelationship-error' : undefined}
                >
                    {Object.keys(getRelationShip).map((key: any) => (
                        <MenuItem value={key}>{getRelationShip[key]}</MenuItem>
                    ))}
                </Select>
                {mobileFormik.errors.mobileRelationship && (
                    <FormHelperText
                        id="mobileRelationship-error"
                        style={{ color: 'red', padding: 0, fontSize: 12 }}
                        role="alert"
                    >
                        {showHelperText(mobileFormik, 'mobileRelationship')}
                    </FormHelperText>
                )}
            </FormControl>
        </div>
    );
}
